// @ts-nocheck

import React from 'react';
import Head from 'react-helmet';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import styled from 'styled-components';

import AreaActions from 'app/shared/flux/actions/AreaActions';
import { areaUtils_exploreLinks } from 'app/shared/utils/areaUtils';
import Center from 'app/shared/modules/Center';
import Container from 'app/shared/core/Container';
import FetchListingActions from 'app/shared/flux/actions/FetchListingActions';
import ListingWrapper from 'app/shared/modules/listing-cards/ListingWrapper';
import ReviewSuccessImage from 'images/reviewsuccess.svg';
import Row from 'app/shared/core/Row';
import Section from 'app/shared/modules/Section';
import Text from 'app/shared/core/Text';
import Title from 'app/shared/modules/Title';
import Linker from 'app/shared/modules/Linker';
import pathsManifest from 'app/shared/utils/pathsManifest';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import './style.scss';
import UserSearchActions from 'app/shared/flux/actions/UserSearchActions';
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';

const StyledBoldText = styled(Text)`
  font-weight: 700;
`;
const StyledBoldRow = styled(Row)`
  font-weight: 700;
`;
class FeedbackSuccessPage extends React.Component {
  constructor(props) {
    super(props);
    const { dispatch } = props;

    this.state = {
      exploreLinks: [],
    };
  }

  componentDidMount() {
    const { dispatch, currentListing, filter, geolocation } = this.props;

    if (currentListing && currentListing.maloneLotIdEncoded) {
      dispatch(
        AreaActions.getAreaByLatLon({
          lat: currentListing.geo.lat,
          lon: currentListing.geo.lon,
        }),
      ).then((area) => {
        if (!isEmpty(area)) {
          const exploreLinks = areaUtils_exploreLinks({ area, filter });

          this.setState({
            exploreLinks,
          });
        }
      });

      dispatch(
        FetchListingActions.fetchSimilarListings({
          maloneLotIdEncoded: currentListing.maloneLotIdEncoded,
          unit: currentListing.unit,
          listingTypes: currentListing.listingType,
        }),
      );
    } else {
      dispatch(UserSearchActions.getRecentSearches()).then((data) => {
        // Prioritize recent search; geolocation as fallback
        const area = (data && data.areaInfo) || geolocation;

        dispatch(FetchListingActions.fetchSimilarListingsByCoords({ area, limit: 20, filter })).catch((error) => {
          dispatch(
            ErrorActions.errorHandler({
              error,
              errorLocation: 'component.feedbackSuccessPage.componentDidMount',
              errorClass: 'fetchListingActions',
            }),
          );
        });
      });
    }
  }
  serverRouteWillMount(reactContext) {
    const store = reactContext.store;
    const dispatch = store.dispatch;
    const aliasEncoded = reactContext.state.query.aliasEncoded || reactContext.state.query.listingAlias;

    const promises = [];

    if (aliasEncoded) {
      promises.push(
        dispatch(FetchListingActions.fetchListingByAliasEncoded({ aliasEncoded, shouldSkipRedirect: true }))
          .then((response) => {
            const listing = response.listing;

            if (!listing) {
              return false;
            }

            return dispatch(ListingEngineActions.setCurrentListing(listing));
          })
          .catch((error) => {
            dispatch(
              ErrorActions.errorHandler({
                error,
                errorLocation: 'component.feedbackSuccessPage.serverRouteWillMount',
                errorClass: 'listingEngineActions',
              }),
            );
          }),
      );
    }

    return promises;
  }
  render() {
    const { similarListings } = this.props;
    const { exploreLinks } = this.state;

    return (
      <div className="FeedbackSuccessPage">
        <Head title="Thank you! | HotPads" />
        <Container>
          <Section>
            <Center>
              <div className="FeedbackSuccessPage-form-complete-images">
                <img src={ReviewSuccessImage} width={140} className="FeedbackSuccessPage-review-success" alt="" />
              </div>
              <StyledBoldText size="lg">Thanks for the feedback!</StyledBoldText>
              <Row size="md">
                We appreciate you taking the time to fill out the survey. Your opinion means the world to us.
              </Row>

              {!isEmpty(similarListings) && (
                <StyledBoldRow size="md">Check out some listings we recommend for you:</StyledBoldRow>
              )}
              <div className="FeedbackSuccessPage-similar-listings">
                {!isEmpty(similarListings) &&
                  map(similarListings, (similarListing, i) => {
                    return (
                      <ListingWrapper
                        listing={similarListing}
                        key={i}
                        home_details
                        triggerLocation="home_details"
                        triggerObject="property_card"
                      />
                    );
                  })}
              </div>
              <Row size="md">
                <div className="FeedbackSuccessPage-sub-column">
                  <Title size="md">Other things to do</Title>
                  <div>
                    <Linker to="mailto:info@hotpads.com">Report an issue</Linker>
                  </div>
                  <div>
                    <Linker to={pathsManifest.FrontPage}>Go home</Linker>
                  </div>
                </div>
              </Row>
              <Row size="md">
                <div className="FeedbackSuccessPage-sub-column">
                  {exploreLinks && exploreLinks.length > 0 && (
                    <div>
                      <Title size="md"> Search for hot rentals in</Title>
                      <ul>
                        {exploreLinks.map((city, i) => {
                          return (
                            <li key={'city' + i}>
                              <Linker to={city.uri}>{city.name}</Linker>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </Row>
            </Center>
          </Section>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentListing: state.currentListingDetails.currentListing,
  similarListings: state.fetchListing.similarListings,
  filter: state.filter,
  geolocation: state.geolocation.area,
});

export default connect(mapStateToProps)(FeedbackSuccessPage);
